import axios from '../axios';

export const getLiveStreamApiURL = (path) => {
  const baseUrl = (process.env.REACT_APP_STREAM_URL || '').trim().replace(/\/+$/, '');
  if (!baseUrl) throw new Error('Live stream URL is unavailable.');
  return `${baseUrl}/api/${path}`;
};

// Points use normalized coordinates (0..1) so zones scale with the player.
export const getLiveZoneCameras = async (clientId) => {
  if (![1442, 1444].includes(Number(clientId))) return [];
  const response = await axios.get(getLiveStreamApiURL('cameras'), { timeout: 30000 });
  if (!Array.isArray(response.data)) throw new Error('Invalid cameras response');
  return response.data.map((camera) => ({
    id: String(camera.deviceid ?? camera.live_id ?? camera.id),
    name: camera.name || String(camera.deviceid ?? camera.id),
    viewId: camera.view_id,
  }));
};

export const getLiveZones = async ({ cameraId, viewId }) => {
  if (viewId === null || viewId === undefined) return [];
  const response = await axios.get(getLiveStreamApiURL(`cameras/${encodeURIComponent(cameraId)}/zones`), {
    params: { view_id: viewId }, timeout: 30000,
  });
  if (response.status === 204 || response.data === null || response.data === '') return [];
  if (!Array.isArray(response.data)) throw new Error('Invalid zones response');
  return response.data.map((zone) => ({
    ...zone,
    replaceId: zone.id,
    points: zone.polygon.map(([x, y]) => ({ x, y })),
  }));
};

export const getActiveLiveZones = async (filters) => {
  const zones = await getLiveZones(filters);
  return zones.filter((zone) => zone.end == null
    || (typeof zone.end === 'string' && zone.end.trim() === ''));
};

export const saveLiveZone = async ({ cameraId, zone }) => {
  const response = await axios.post(getLiveStreamApiURL(`cameras/${encodeURIComponent(cameraId)}/zones`), {
    name: zone.name,
    polygon: zone.points.map(({ x, y }) => [x, y]),
    replace_id: zone.replaceId ?? null,
  }, {
    headers: { 'Content-Type': 'application/json' },
    timeout: 30000,
  });
  const result = response.data?.zone || response.data?.data || response.data;
  const replaceId = result?.id ?? result?.zone_id ?? zone.replaceId ?? null;
  const saved = {
    ...zone,
    id: replaceId ?? zone.id ?? `${Date.now()}-${Math.random().toString(36).slice(2)}`,
    replaceId,
  };
  return saved;
};

export const deleteLiveZone = async ({ cameraId, zoneId }) => {
  await axios.delete(getLiveStreamApiURL(`cameras/${encodeURIComponent(cameraId)}/zones/${encodeURIComponent(zoneId)}`), {
    timeout: 30000,
  });
};
